import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { bulletinAttachmentResponseSchema } from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'

import { get } from 'api/apiClient'
import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'
import { useCurrentBulletin } from 'hooks/useCurrentBulletin/useCurrentBulletin'

const params = (
  uuid: string,
  bulletinUuid: string,
  attachmentUuid: string
) => ({
  queryKey: [
    `${API_ENDPOINTS.CONTRACTS}/${uuid}/bulletins/${bulletinUuid}/attachments/${attachmentUuid}`,
  ],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${uuid}/bulletins/${bulletinUuid}/attachments/${attachmentUuid}`,
      bulletinAttachmentResponseSchema
    ),
  enabled: false, // don't fetch by default
})

export const useAPIGetBulletinAttachment = (attachmentUuid: string) => {
  const { currentContractId } = useCurrentContract()
  const { bulletinUuid } = useCurrentBulletin()

  const query = useQuery({
    ...params(currentContractId, bulletinUuid, attachmentUuid),
    throwOnError() {
      throw ResidentAppError.ClientError('FILE_FAILED_TO_LOAD', {
        message: 'Failed to fetch attachment',
      })
    },
  })

  return query
}
